
(() => {
  // ATHLETEGY - Shop the Look Quick Buy color synchronization

  function initializeShopLookQuickBuy() {
    const cards = document.querySelectorAll(
      ".shopify-section--shop-the-look .product-card"
    );

    cards.forEach((card) => {
      if (card.dataset.athletegyQuickBuySync === "true") return;

      const productLink = card.querySelector(".product-card__media");
      const button = card.querySelector(
        ".product-card__quick-add-button[aria-controls]"
      );

      if (!productLink || !button) return;

      const modal = document.getElementById(
        button.getAttribute("aria-controls")
      );

      if (!modal) return;

      function synchronizeVariant() {
        const url = new URL(productLink.href, window.location.href);
        const variantId = url.searchParams.get("variant");
        const productHandle = card.getAttribute("handle");
        const detailsLink = card.querySelector(
  ".athletegy-shop-look-details"
);

if (detailsLink) {
  detailsLink.href = productLink.href;
}

        if (!variantId || !productHandle) return;

        const newHandle =
          `${productHandle}?variant=${encodeURIComponent(variantId)}`;

        if (modal.getAttribute("handle") !== newHandle) {
          modal.setAttribute("handle", newHandle);
        }
      }

      // Watch for changes to the product's selected color.
      const observer = new MutationObserver(synchronizeVariant);

      observer.observe(productLink, {
        attributes: true,
        attributeFilter: ["href"]
      });

      // Also synchronize before the Quick Buy button is activated.
      button.addEventListener("pointerdown", synchronizeVariant);
      button.addEventListener("click", synchronizeVariant, true);

      synchronizeVariant();

      card.dataset.athletegyQuickBuySync = "true";
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeShopLookQuickBuy
    );
  } else {
    initializeShopLookQuickBuy();
  }

  document.addEventListener(
    "shopify:section:load",
    initializeShopLookQuickBuy
  );
})();
